import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Button, message, Input, InputNumber, Form, Modal, Select, Popconfirm} from 'antd';
import {DmsTab, TableView} from 'Components';
import {fetchList, updateItemMap, addItemMap, removeItemMap} from '../../service/invoiceItemMap';
import moment from 'moment';
import {openNotice} from 'Utils';
import {AdvanceFormNew} from "../../components";
import {getGouXiaoUnitList} from "../../service/traceOrder";

const FormItem = Form.Item;
const Option = Select.Option;

class InvoiceItemMapList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['物料开票信息维护'],
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
            rows: [],
            total: 0,
            searchObj: {
                purchaseId: '',
                itemNum: '',
                itemDesc: '',
                p: 1,
                s: 10
            },
            loading: true,
            channel_GouHuo: [],
            visible: false
        };

        this.pageChange = this.pageChange.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                });
                this.setState({channel_GouHuo: arr},
                )
            }
        });
        this.getData();
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    //请求数据
    getData = () => {
        fetchList(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    advanceSubmit = (form) => {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            },
            loading: true
        }, function () {
            this.getData();
        });

    };

    advanceReset = () => {
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                p: 1
            }, loading: true
        }, () => {
            this.getData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    };

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            this.getData();
        });
    }

    edit(record) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                item.edit = true;
            }
        })
        this.setState({
            rows: this.state.rows
        });
    }

    save(record) {
        const {rows} = this.state;

        updateItemMap(record).then(res => {
            if (res.code === 200 && res.status) {
                openNotice('success', res.message, '');
                rows.forEach(item => {
                    if (item.id === record.id) {
                        item.edit = false;
                    }
                });
                this.setState({
                    rows: this.state.rows
                })
            } else {
                openNotice('error', res.message, '');
            }
        })
    }

    del(record) {
        removeItemMap(record).then(res => {
            if (res.code === 200 && res.status) {
                openNotice('success', res.message, '');
                this.getData();
            } else {
                openNotice('error', res.message, '');
            }
        })
    }

    changeInput(e, record, type) {
        const {rows} = this.state;
        rows.forEach(item => {
            if (item.id === record.id) {
                if (type == "custItemPrice") {
                    item[type] = e;
                } else {
                    item[type] = e.target.value;
                }
            }
        });
        this.setState({
            rows: this.state.rows,
        });
    }

    showModal = () => {
        this.setState({visible: true});
    }

    saveFormRef = (form) => {
        this.form = form;
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    handleCreate = () => {
        const form = this.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            addItemMap(values).then((result) => {
                if (result && result.code == 200 && result.status) {
                    openNotice('success', result.message, '');
                    this.getData();
                    form.resetFields();
                    this.setState({visible: false});
                } else {
                    openNotice('error', result.message, '');
                }
            });
        });
    }

    render() {
        const {
            opts,
            rows,
            total,
            searchObj,
            loading,
            channel_GouHuo
        } = this.state;

        const options = this.state.channel_GouHuo.map(d => <Option key={d.value}>{d.text}</Option>);

        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'purchaseId',
                    label: '购货单位',
                    text: '选择购货单位',
                    options: channel_GouHuo,
                    multiple: false,//支持多选
                    showSearch: true,
                    allowClear: true,
                    type: 'select',
                    defaultValue: searchObj.purchaseId
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '客户物料编码',
                    dataIndex: 'custItemNum',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'custItemNum')
                        }}/> : text)
                },
                {
                    title: '客户物料描述',
                    dataIndex: 'custItemDesc',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'custItemDesc')
                        }}/> : text)
                },
                {
                    title: '客户物料类别',
                    dataIndex: 'custItemType',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'custItemType')
                        }}/> : text)
                },
                {
                    title: '客户物料价格',
                    dataIndex: 'custItemPrice',
                    render: (text, record) => (record.edit ?
                        <InputNumber value={text} onChange={(e) => {
                            this.changeInput(e, record, 'custItemPrice')
                        }}/> : text)
                },
                {
                    title: '客户物料单位',
                    dataIndex: 'custItemUnit',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'custItemUnit')
                        }}/> : text)
                },
                {
                    title: '扩展字段1',
                    dataIndex: 'attribute1',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'attribute1')
                        }}/> : text)
                },
                {
                    title: '扩展字段2',
                    dataIndex: 'attribute2',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'attribute2')
                        }}/> : text)
                },
                {
                    title: '扩展字段3',
                    dataIndex: 'attribute3',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'attribute3')
                        }}/> : text)
                },
                // {
                //     title: '扩展字段4',
                //     dataIndex: 'attribute4',
                //     render: (text, record) => (record.edit ?
                //         <Input value={text} onChange={(e) => {
                //             this.changeInput(e, record, 'attribute4')
                //         }}/> : text)
                // },
                // {
                //     title: '扩展字段5',
                //     dataIndex: 'attribute5',
                //     render: (text, record) => (record.edit ?
                //         <Input value={text} onChange={(e) => {
                //             this.changeInput(e, record, 'attribute5')
                //         }}/> : text)
                // },
                {
                    title: '更新时间',
                    dataIndex: 'lastUpdateDate',
                    render: (text, record) => {
                        return moment(Number(text)).format('YYYY-MM-DD HH:mm:ss')
                    }
                },
                {
                    title: '操作',
                    width: '8%',
                    render: (text, record, index) => {
                        if (record.edit) {
                            return <div>
                                <Button type="primary" size={'small'}
                                        onClick={() => {
                                            this.save(record)
                                        }}
                                >保存
                                </Button></div>
                        } else {
                            return <div>
                                <Button size={'small'} style={{display: 'inline-block', marginRight: '10px'}}
                                        onClick={() => {
                                            this.edit(record)
                                        }}
                                >修改</Button>
                                <Popconfirm placement="left"
                                            title='您确定是否要删除？'
                                            onConfirm={() => {
                                                this.del(record)
                                            }}>
                                    <Button size={'small'} type="danger">删除</Button>
                                </Popconfirm>
                            </div>
                        }
                    }
                }
            ],
            rows: rows
        };

        const CollectionCreateForm = Form.create()(
            (props) => {
                const {visible, onCancel, onCreate, form} = props;
                const {getFieldDecorator} = form;
                const formItemLayout = {
                    labelCol: {span: 6},
                    wrapperCol: {span: 14},
                }
                return (
                    <Modal
                        visible={visible}
                        title="新建"
                        okText="提交"
                        onCancel={onCancel}
                        onOk={onCreate}
                        maskClosable={false}
                    >
                        <Form layout='horizontal'>
                            <FormItem label="购货单位" {...formItemLayout}>
                                {getFieldDecorator('purchaseId', {
                                    rules: [{required: true, message: '购货单位不能为空'}],
                                })(
                                    <Select
                                        placeholder="请选择购货单位"
                                        notFoundContent="无购货单位可选"
                                    >
                                        {options}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem label="天正物料编码" {...formItemLayout}>
                                {getFieldDecorator('itemNum', {
                                    rules: [{required: true, message: '物料编码不能为空'}],
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="客户物料编码" {...formItemLayout}>
                                {getFieldDecorator('custItemNum', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="客户物料描述" {...formItemLayout}>
                                {getFieldDecorator('custItemDesc', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="客户物料类型" {...formItemLayout}>
                                {getFieldDecorator('custItemType', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="客户物料价格" {...formItemLayout}>
                                {getFieldDecorator('custItemPrice', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="客户物料单位" {...formItemLayout}>
                                {getFieldDecorator('custItemUnit', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="扩展字段1" {...formItemLayout}>
                                {getFieldDecorator('attribute1', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="扩展字段2" {...formItemLayout}>
                                {getFieldDecorator('attribute2', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="扩展字段3" {...formItemLayout}>
                                {getFieldDecorator('attribute3', {})(
                                    <Input/>
                                )}
                            </FormItem>
                            {/*<FormItem label="扩展字段4" {...formItemLayout}>*/}
                            {/*    {getFieldDecorator('attribute4', {})(*/}
                            {/*        <Input/>*/}
                            {/*    )}*/}
                            {/*</FormItem>*/}
                            {/*<FormItem label="扩展字段5" {...formItemLayout}>*/}
                            {/*    {getFieldDecorator('attribute5', {})(*/}
                            {/*        <Input/>*/}
                            {/*    )}*/}
                            {/*</FormItem>*/}
                        </Form>
                    </Modal>
                );
            }
        );

        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button icon="plus" onClick={this.showModal}>新增</Button>
                        <CollectionCreateForm
                            ref={this.saveFormRef}
                            visible={this.state.visible}
                            onCancel={this.handleCancel}
                            onCreate={this.handleCreate}
                        />
                    </DmsTab>
                </div>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">
                        <AdvanceFormNew {...advanceProps}/>
                    </div>
                </div>
                <div className="dms-table-box">
                    <TableView {...tableViewProps} />
                </div>
            </div>
        )
    }
};
export default withRouter(InvoiceItemMapList);




// WEBPACK FOOTER //
// ./src/routes/invoiceItemMap/list.js